<template>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
                      style="min-height: 300px"
                      pulling-text="下拉重新获取数据"
                      loosing-text="释放即可重新加载"
                      loading-text=""
                      success-text="数据获取成功">
        <div :style="{minHeight: screeHeight + 'px'}">
            <div style="min-height: 130px; background-color: #DC2011; padding: 10px">
                <van-cell style="background-color: #DC2011; color: white" :border="false">

                    <van-image class="user_icon" slot="icon" :src="user_icon" round />
                    <div slot="title" style="margin-left: 15px; font-size: 15px; font-weight: bold;margin-top: 10px;">
                        <div>
                            <span style="font-size: 18px">{{user_name}}</span>
                            <span v-if="login_u_name" style="">({{login_u_name}})</span>
                            <van-tag v-if="member_level" plain round type="danger"
                                     style="margin-left: 5px; position: absolute;margin-top: 5px; padding: 1px 7px" >{{member_level}}</van-tag>
                        </div>
<!--                        <div style="margin-top: 5px; font-size: 15px">-->
<!--                            <span v-if="login_u_name" style="">群编号 {{login_u_name}}</span>-->
<!--                            <van-tag v-if="member_level" plain round type="danger"-->
<!--                                     style="margin-left: 5px; position: absolute;margin-top: 0px; padding: 1px 7px" >{{member_level}}</van-tag>-->
<!--                        </div>-->
                        <div v-if="u_code" style="margin-top: 5px; font-size: 13px">
                            <span>邀请码 </span>
                            <span>{{u_code}} </span>
                        </div>
                    </div>
                </van-cell>

                <div v-if="channel_id" style="padding: 0px 15px 20px 15px">
                    <div style="padding-bottom: 10px" >
                        <span style="font-size: 15px; color: white">近30天活跃值
                            <span v-if="show_active_value">{{active_value}}</span>
                            <span v-else>****</span>
                        </span>

                        <van-icon :name="eye_icon_name" size="20px" color="#FFFFFF"
                                  style="position: absolute; margin-top: 1px; margin-left: 7px;"
                                  @click="eyeIconClick"/>
                    </div>
                    <div v-if="show_active_value" style="padding-bottom: 20px">
                        <div style="padding: 5px 0px" @click="showActiveValueDetail">
                            <van-progress :pivot-text="active_value"
                                          :percentage="active_value_percent"
                                          pivot-color="#1989fa"
                                          color="linear-gradient(to right, #be99ff, #1989fa)"
                            />
                        </div>

<!--                        <div style="color: white">-->
<!--                            <span style="float: left">0</span>-->
<!--                            <span style="float: right">{{max_active_value}}</span>-->
<!--                        </div>-->

                    </div>

                </div>
            </div>

            <div style="width: 100%; position: absolute; padding-left: 20px; padding-right: 20px; margin-top: -25px">
                <van-cell is-link size="large" title="收益提现" value="提现"
                          style="border-radius: 5px; box-shadow: 1px 1px 5px #999999"
                          @click="clickToCashout">
                </van-cell>
            </div>

            <div style="padding-top: 20px; ">

<!--                <div style=" margin-top: 20px; box-shadow: 1px 1px 5px #999999">-->
<!--                    <Wp_robot_public_on_off_model></Wp_robot_public_on_off_model>-->
<!--                </div>-->

                <div style="padding-top: 20px;">
                    <Wp_mini_data_card title="我的粉丝" :datas="level_count_total_list" @clickMore="clickToMoreMember">
                        <div v-if="!channel_id" slot="bottom" style="background-color: #ffd8ac33; text-align: center; padding-top: 5px; padding-bottom: 5px">
                            <div style="color: #ce9b0b ; font-size: 14px;">建50人推广群即可升级超级会员，开启赚钱特权</div>
                            <van-button style="margin-top: 5px" size="small" type="danger" @click="clickToUpgrade">立即升级</van-button>
    <!--                        <van-row >-->
    <!--                            <van-col span="19">-->
    <!--                                -->
    <!--                            </van-col>-->
    <!--                            <van-col span="5" style="text-align: center; height: 40px; line-height: 40px">-->
    <!--                                -->
    <!--                            </van-col>-->
    <!--                        </van-row>-->
                        </div>
                    </Wp_mini_data_card>


                </div>
                <div style="padding-top: 20px">
                    <Wp_mini_data_card title="我的代理" @clickMore="clickToChildMember">

                    </Wp_mini_data_card>
                </div>
                <div style="padding-top: 20px">
                    <Wp_mini_data_card title="我的收益"
                                       :datas="today_income_list"
                                       @clickMore="clickToMoreIncome"
                                       :show-question="false"
                                       :question-content="question_income"
                    >
                    </Wp_mini_data_card>
                </div>

                <div style="padding-top: 20px">
                    <Wp_mini_data_card title="我的订单"
                                       :datas="order_total_list"
                                       @clickMore="clickToOrders"
                                       :show-question="false"
                                       :question-content="question_order"
                    ></Wp_mini_data_card>
                </div>

                <div style="padding-top: 15px">
                    <van-divider style="padding: 0px; padding: 0px 16px; color: #aaaaaa; border-color: #aaaaaa">下拉刷新页面</van-divider>
                </div>

            </div>
        </div>
    </van-pull-refresh>
</template>

<script>
    import Wp_mini_data_card from "../custom/Wp_mini_data_card";
    import Wp_robot_public_on_off_model from "../custom/Wp_robot_public_on_off_model";
    export default {
        name: "Wp_mini_member",
        components: {Wp_robot_public_on_off_model, Wp_mini_data_card},
        data(){
            return{
                user_icon:"",
                user_name:"",
                login_u_name: "",
                channel_id: "",
                role_id: '',
                member_level: "",
                u_code: "",

                pid: this.$common.getPid(),
                // pid: "1819440868",

                test1:[
                    {
                        count: 10,
                        count_unit: "人",
                        text: "今日直属"
                    },
                    {
                        count: 50,
                        count_unit: "人",
                        text: "全部直属"
                    },
                    {
                        count: 100,
                        count_unit: "人",
                        text: "全部粉丝"
                    },
                    {
                        count: 100,
                        count_unit: "人",
                        text: "全部粉丝"
                    }
                ],

                level_count_total_list: [],

                today_income_list:[],

                order_total_list:[],

                isLoading: false,

                screeHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,

                eye_icon_name: "eye-o",

                show_active_value: true,

                max_active_value: 3000,

                active_value: "0",

                tuiguang_active_value: "0",
                tuijian_active_value: "0",

                active_value_percent: 0,

                question_income: "'我的收益'为预估收益，实际收益数据以订单中[已完成]订单的收益为准",
                question_order: "'我的订单'为全部订单数据，包括'已完成'、'已付款'、'待付款'、'已取消'等所有状态的订单数据",

                createTime: '',
                is_in_limit_time: false,
            }
        },

        created() {

            this.initUserInfoData();

            // this.$log()

            this.getGroupActiveValue();

            this.getLevelCountTotal();

            this.initTodayIncome();

            this.initOrderTotalData();


            this.getUserInfo();
        },

        methods:{

            getUserInfo(){
                let params = {
                    pid: this.$store.state.pid
                }
                this.$getUserInfo(params, response=>{
                    if(response && response.code === 200){
                        if(response.data && response.data.length > 0){
                            //2019-11-08 14:51:42.0
                            this.createTime = response.data[0].u_createtime;

                            this.is_in_limit_time = this.$common.isInLimitTime(this.createTime, '2020-1-1', '2020-4-30');
                        }
                    }
                })
            },

            eyeIconClick(){
                if(this.show_active_value){
                    this.eye_icon_name = "closed-eye";
                    this.show_active_value = false;
                }else{
                    this.eye_icon_name = "eye-o";
                    this.show_active_value = true;
                }
            },

            showActiveValueDetail(){
                let params = "all_value=" + this.active_value;
                params += "&tuiguang_value=" + this.tuiguang_active_value;
                params += "&tuijian_value=" + this.tuijian_active_value;
                params += "&role_id=" + this.role_id;
                this.$router.push('mini_active_value?' + params)
            },

            /**
             * 获取当前群号的活跃值
             */
            getGroupActiveValue(){
                let params = {
                    // uid: 'v162'
                    uid: this.$store.state.username
                };
                this.$log("params.uid = " + params.uid)
                this.$getGroupActiveValue(params, response=>{
                    this.$log(response)
                    //{msg: "成功", code: 200, u_mark: "S101", points: "0"}
                    if(response && response.code === 200){
                        this.active_value = response.points;
                        this.active_value_percent = Number(response.points) / this.max_active_value  * 100;
                        if(this.active_value_percent > 100){
                            this.active_value_percent = 100;
                        }

                        this.tuiguang_active_value = response.user_points;

                        let tuijian_data = response.data;
                        let tuijian_value = 0;
                        for(let i = 0; i < tuijian_data.length; i++){
                            if(tuijian_data[i].points){
                                tuijian_value += Number(tuijian_data[i].points);
                            }
                        }

                        this.tuijian_active_value = tuijian_value;

                        // this.active_value_percent = 100;
                        // this.active_value = "31230";
                        // this.active_value_percent = Number(this.active_value) / this.max_active_value * 100;
                        // this.$log("this.active_value_percent = " + this.active_value_percent);
                    }
                })
            },

            /**
             * 初始化用户数据
             */
            initUserInfoData(){
                if(this.$common.gloabl_wx_mini_user_info){
                    let userInfo = this.$common.gloabl_wx_mini_user_info;
                    this.user_icon = userInfo.headimgurl;
                    this.user_name = userInfo.nickname;
                    this.login_u_name = userInfo.channel_name;
                    this.channel_id = userInfo.channel_id;
                    if(this.channel_id){
                        this.role_id = userInfo.role_id;
                        if(this.role_id === "0") {
                            this.member_level = "超级会员";
                        }else if(this.role_id === "1"){
                            this.member_level = "教练";
                        }else if(this.role_id === "2"){
                            this.member_level = "高级教练";
                        }else if(this.role_id === "3"){
                            this.member_level = "合伙人";
                        }
                    }else{
                        this.member_level = "普通会员";
                    }

                    this.u_code = userInfo.u_code;
                }else{
                    this.$dialog.alert({
                        message: "用户数据异常，请退出重新登录"
                    })
                }
            },

            /**
             * 下拉刷新
             */
            onRefresh() {
                this.isLoading =false;
                window.location.reload();
            },

            getLevelCountTotal(){

                let params = {
                    // uid: "s140"
                    uid: this.$store.state.username
                };
                //测试
                // this.channel_id = this.pid;

                this.$getLevelCountTotal(params, response=>{
                    this.$log(response)
                    if(response && response.code === 200){

                        this.getZhishuNormalFans(total=>{
                            let zhishu_normal = total;

                            let zhishu_super = Number(response.twonum) + Number(response.threenum);//直属超级为下级+下下级

                            let all_super = Number(response.num);

                            let all_fans = all_super + zhishu_normal;

                            if(response.u_type === 0){//超级会员
                                this.level_count_total_list = [
                                    {
                                        count: zhishu_normal,
                                        count_unit: "人",
                                        text: "普通会员"
                                    },
                                    {
                                        count: zhishu_super,
                                        count_unit: "人",
                                        text: "超级会员"
                                    }
                                    // ,
                                    // {
                                    //     count: all_super,
                                    //     count_unit: "人",
                                    //     text: "全部超级会员"
                                    // }
                                ];
                            }else if(response.u_type === 1 || response.u_type === 2  || response.u_type === 2) {//教练or高级教练
                                this.level_count_total_list = [
                                    {
                                        count: zhishu_normal,
                                        count_unit: "人",
                                        text: "普通会员"
                                    },
                                    {
                                        count: zhishu_super,
                                        count_unit: "人",
                                        text: "超级会员"
                                    },
                                    {
                                        count: all_super,
                                        count_unit: "人",
                                        text: "全部超级会员"
                                    },
                                    {
                                        count: all_fans,
                                        count_unit: "人",
                                        text: "全部会员"
                                    }
                                ];
                            }else{
                                // this.level_count_total_list = [
                                //     {
                                //         count: zhishu_normal + zhishu_super,
                                //         count_unit: "人",
                                //         text: "全部会员"
                                //     }
                                // ];
                            }

                        })
                    }
                })
            },

            /**
             * 获取直属普通会员数
             */
            getZhishuNormalFans(fn){

                let params = {
                    id: this.$common.gloabl_wx_mini_user_info.id,
                    role: -1,
                    page: 1,
                    size: 1,
                };

                this.$getFansList(params, respones=>{
                    this.$log(respones)
                    if(respones && respones.code === 200 && respones.total >= 0){
                        if(fn){
                            fn(respones.total)
                        }
                    }else{
                        if(fn){
                            fn(0)
                        }
                    }
                })
            },

            /**
             * 初始化"我的收益"数据
             */
            initTodayIncome(){
                let time = this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', 0, new Date()));
                let _data = {
                    pid: this.pid,
                    stime: time,
                    etime: time,
                };

                this.$getIncometByData(_data, response=> {
                    this.$log(response)
                    if(response && response.code === 200){
                        if(response.type === "0"){

                            this.today_income_list = [
                                {
                                    count: response.efeetodayall_user.toFixed(2),
                                    count_unit: "￥",
                                    text: "今日推广收益"
                                },
                                {
                                    count: response.efeetodayall_he.toFixed(2),
                                    count_unit: "￥",
                                    text: "今日推荐收益"
                                },
                                {
                                    count: response.efeetodayall.toFixed(2),
                                    count_unit: "￥",
                                    text: "今日全部收益"
                                }
                            ];
                        }else if(response.type === "1" || response.type === "2"){

                            this.today_income_list = [
                                {
                                    count: response.efeetodayall_user.toFixed(2),
                                    count_unit: "￥",
                                    text: "今日推广收益"
                                },
                                {
                                    count: response.efeetodayall_he.toFixed(2),
                                    count_unit: "￥",
                                    text: "今日推荐收益"
                                },
                                {
                                    count: response.efeetodayall_other.toFixed(2),
                                    count_unit: "￥",
                                    text: "今日专属收益"
                                },
                                {
                                    count: response.efeetodayall.toFixed(2),
                                    count_unit: "￥",
                                    text: "今日全部收益"
                                }
                            ];
                        }else{
                            this.today_income_list = [
                                {
                                    count: 0,
                                    count_unit: "￥",
                                    text: "今日收益"
                                }
                            ];
                        }
                    }
                })

            },

            /**
             * 初始化"我的订单"数据
             */
            initOrderTotalData(){

                this.getOrderTotalData(data=>{
                    if(data && data.length === 2){

                        if(data[0].day === -1){//如果第一个数据是昨日数据
                            let temp = data[1];//将今日数据缓存
                            //删除
                            data.splice(1, 1);
                            //将缓存的今日数据放到第一位
                            data.unshift(temp);
                        }
                        this.order_total_list = data;
                        this.$log("this.order_total_list.length = " + this.order_total_list.length)
                    }
                })
            },

            /**
             * 初始化"我的订单"数据
             */
            getOrderTotalData(fn){
                let total_data = [];
                let current_date = new Date(new Date().toLocaleDateString());
                let current_date_params = this.getDateParamsByDate(current_date);
                this.getOrderCount(current_date_params, response=>{
                    let current_total = response.total;
                    total_data.push({
                        day: 0,//0表示今天
                        count: current_total,
                        count_unit: "",
                        text: "今日购买订单量"
                    });
                    if(total_data.length === 2 && fn){
                        fn(total_data)
                    }
                });

                let yesterday_date = this.$common.dateAdd('d', -1, new Date(new Date().toLocaleDateString()));
                let yesterday_date_params = this.getDateParamsByDate(yesterday_date);
                this.getOrderCount(yesterday_date_params, response=>{
                    let yesterday_total = response.total;
                    total_data.push({
                        day: -1,//-1表示昨天
                        count: yesterday_total,
                        count_unit: "",
                        text: "昨日购买订单量"
                    });
                    if(total_data.length === 2 && fn){
                        fn(total_data)
                    }
                });
            },

            getDateParamsByDate(date){
                let _startTime = this.$common.dateFmt("yyyy-MM-dd 00:00:00", date);
                let endDate = new Date(date.getTime() + 24 * 60 * 60 * 1000 - 1);
                let _endTime = this.$common.dateFmt("yyyy-MM-dd hh:mm:ss", endDate);
                let date_params = {
                    startTime: _startTime,
                    endTime: _endTime
                }
                return date_params;
            },

            // initOrderCountData(){
            //
            //     let date_params = this.getDateParams();
            //
            //     this.getOrderCount(date_params, response=>{
            //         this.$log("11111")
            //         this.$log(response)
            //         let total = response.total;
            //         let data = response.data;
            //
            //         let temp_current_count = 0;
            //         //今日日期
            //         let current_date_str = this.$common.dateFmt("yyyy-MM-dd", new Date());
            //
            //         for(let i = 0; i < data.length; i++){
            //             //如果订单时间包含今日日期，则表示为今日订单
            //             if(data[i].orderTime_Date.indexOf(current_date_str) !== -1){
            //                 temp_current_count++
            //             }
            //         }
            //
            //         let current_order_count = temp_current_count;
            //         let yesterday_order_count = total - current_order_count;
            //
            //         this.order_data_list = [
            //             {
            //                 count: current_order_count,
            //                 count_unit: "",
            //                 text: "今日购买订单量"
            //             },
            //             {
            //                 count: yesterday_order_count,
            //                 count_unit: "",
            //                 text: "昨日购买订单量"
            //             }
            //         ]
            //
            //     });
            // },
            //
            // getDateParams(){
            //     //开始时间为昨日0点
            //     let yesterday_date = this.$common.dateAdd('d', -1, new Date(new Date().toLocaleDateString()));
            //     let _startTime = this.$common.dateFmt("yyyy-MM-dd 00:00:00", yesterday_date);
            //     //结束时间为今日24点（毫秒-1）
            //     let current_date = new Date(new Date().toLocaleDateString());
            //     let endDate = new Date(current_date.getTime() + 24 * 60 * 60 * 1000 - 1);
            //     let _endTime = this.$common.dateFmt("yyyy-MM-dd hh:mm:ss", endDate);
            //     let date_params = {
            //         startTime: _startTime,
            //         endTime: _endTime
            //     }
            //     return date_params;
            // },


            getOrderCount(date_params, fn) {
                // let params = this.getBaseParams();
                let params = {
                    pid: this.pid,
                    isValid: '0',
                    orderid: '',
                    stime: date_params.startTime,
                    etime: date_params.endTime,
                    page: 1,
                    size: 1,
                    sort: 'desc',
                    phone: this.$common.gloabl_wx_mini_user_info.phone
                };

                // this.$log(params)

                this.$getOrderLogListByData(params, response => {
                    this.$log(response);
                    if(response && response.total >= 0){
                        if (fn) {
                            fn(response);
                        }
                    }else if(response.toString().indexOf("Error: timeout") != -1){
                        this.$dialog.alert({
                            message: "数据加载超时，请重试"
                        })
                    }
                });

            },

            /**
             * 跳转会员升级界面
             */
            clickToUpgrade(){
                // this.$router.push("mini_upgrade");
                this.navigateToUpgrade();
            },
            /**
             * 打开小程序中的升级界面
             */
            navigateToUpgrade() {
                this.$common.navigateToMiniProgramPage("../wp_upgrade/wp_upgrade?");
            },

            clickToMoreMember(){
                // this.$router.push("data3?from=mini");
                // this.$router.push("data?data_type=3");
                this.$router.push("mini_member_fans");
            },

            clickToChildMember(){
                this.$router.push("data?data_type=3");
            },

            clickToMoreIncome(){
                // this.$router.push("data1?from=mini");
                this.$router.push("data?data_type=1");
            },

            clickToOrders(){
                // this.$router.push("data2?from=mini");
                this.$router.push("data?data_type=2");
            },

            clickToCashout(){
                this.$router.push('paydata');

                // if(this.$store.state.userPhone){
                //     this.$router.push('paydata');
                // }else{
                //     this.$dialog.confirm({
                //         message: "请绑定手机号",
                //     }).then(()=>{
                //         this.$router.push("update_phone");
                //     }).catch(()=>{
                //
                //     })
                // }
            }
        }
    }
</script>

<style scoped>

    .user_icon{
        width: 70px;
    }
</style>